import React from 'react';
import { SharedIconCheck } from '../../../shared/icons';

export const DecisionTreeResultFooter: React.FC = () => {
  return (
    <>
      <hr />
      <h3 className={`my-8`}>Check deze belangrijke zaken bij een verbouwing</h3>
      <ul className={`list-none`}>
        <li className={`my-8`}>
          <SharedIconCheck mr={`2`} color={`green.500`} /> Let op lange wachttijden bij
          aannemers/verbouwers.
        </li>
        <li className={`my-8`}>
          <SharedIconCheck mr={`2`} color={`green.500`} />
          Informeer in een vroeg stadium naar eventuele vergunningen/bouwtekeningen.
        </li>
        <li className={`my-8`}>
          <SharedIconCheck mr={`2`} color={`green.500`} />
          Je kunt de financiering pas rond krijgen als de vergunning akkoord is.
        </li>
        <li className={`my-8`}>
          <SharedIconCheck mr={`2`} color={`green.500`} />
          Controleer na je verbouwing of je nog voldoende verzekerd bent.
        </li>
      </ul>
    </>
  );
};
